import React from 'react';

const MarkdownIcon = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      fill="rgba(0,0,0,0.54)"
      d="m14.83923,3.00483l-13.67847,0c-0.63559,0 -1.15268,0.51711 -1.15268,1.15273l0,7.68488c0,0.63565 0.51709,1.15273 1.15268,1.15273l13.67847,0c0.63562,0 1.15268,-0.51708 1.15268,-1.15273l0,-7.68488c0,-0.63562 -0.51705,-1.15273 -1.15268,-1.15273zm-5.84025,7.99032l-1.99798,0.00195l0,-2.9971l-1.49848,1.92122l-1.49848,-1.92122l0,2.9971l-1.99798,0l0,-5.99421l1.99798,0l1.49848,1.99807l1.49848,-1.99807l1.99798,-0.00195l0,5.99421zm2.98278,0.49952l-2.48328,-3.49467l1.49848,0l0,-2.9971l1.99798,0l0,2.9971l1.49848,0l-2.51166,3.49467l0,0z"
    />
  </svg>
);

export default MarkdownIcon;
